export const getSearchResults = async (searchTerm) => {

  const shopifyResponse = await fetch('/api/get-shopify-search-data', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({searchTerm})
  });

  // const contentfulData = await contentfulResponse.json();
  const shopifyData = await shopifyResponse.json();

  return {
    shopifyProducts: shopifyData.shopifyProducts
  };
};
